<div class="column">
  <div class="header">
    <img src="{{ imgPath }}" alt="unauthorized person">
    <div class="header-content">
      <div class="header-content-title heading-h6-medium">{{ sectionTitle }}</div>
      <div class="header-content-text paragraph-large-regular">{{ sectionText }}</div>
    </div>
  </div>
  <div class="vertical-options">
    <app-option-box
    *ngFor="let item of optionsList"
    [option]="item"></app-option-box>
  </div>
</div>